export const links = [
  { name: "Strona główna", id: "#strona-glowna" },
  { name: "O mnie", id: "#o-mnie" },
  { name: "Portfolio", id: "#portfolio" },
  { name: "Cennik", id: "#cennik" },
  { name: "Kontakt", id: "#kontakt" },
];
